// extracted by css-extract-rspack-plugin
export default {"empty-state":"Ax7qiO","emptyState":"Ax7qiO"};